import { supabase } from '../lib/supabase';

const driverAuthService = {
  signIn: async (email, password) => {
    try {
      // Authenticate user
      const { data: authData, error: authError } = await supabase?.auth?.signInWithPassword({
        email,
        password
      });

      if (authError) throw authError;

      // Get employee data
      const { data: employee, error: employeeError } = await supabase
        ?.from('employees')
        ?.select('*')
        ?.eq('auth_user_id', authData?.user?.id)
        ?.eq('role', 'chauffeur')
        ?.eq('is_active', true)
        ?.limit(1)
        ?.single();

      if (employeeError || !employee) {
        await supabase?.auth?.signOut();
        throw new Error('Compte chauffeur introuvable ou inactif.');
      }

      return {
        user: authData?.user,
        session: authData?.session,
        employee: {
          id: employee?.id,
          name: employee?.name,
          email: employee?.email,
          phone: employee?.phone,
          role: employee?.role,
          zone: employee?.zone,
          isActive: employee?.is_active
        }
      };
    } catch (error) {
      console.error('Driver sign in error:', error);
      throw error;
    }
  },

  signOut: async () => {
    try {
      const { error } = await supabase?.auth?.signOut();
      if (error) throw error;
    } catch (error) {
      console.error('Driver sign out error:', error);
      throw error;
    }
  },

  getCurrentDriver: async () => {
    try {
      const { data: { session }, error: sessionError } = await supabase?.auth?.getSession();
      if (sessionError) throw sessionError;
      if (!session?.user) return null;

      const { data: employee, error: employeeError } = await supabase?.from('employees')?.select('*')?.eq('auth_user_id', session?.user?.id)?.single();

      if (employeeError || !employee) {
        return null;
      }

      return {
        user: session?.user,
        session,
        employee: {
          id: employee?.id,
          name: employee?.name,
          email: employee?.email,
          phone: employee?.phone,
          role: employee?.role,
          zone: employee?.zone,
          isActive: employee?.is_active
        }
      };
    } catch (error) {
      console.error('Get current driver error:', error);
      return null;
    }
  }
};

export default driverAuthService;